import React, { useEffect } from 'react';
import {
  View, Text, Pressable, ScrollView, StyleSheet, TextInput,
} from 'react-native';
import Animated, { useAnimatedStyle, useSharedValue, withTiming } from 'react-native-reanimated';
import { useDispatch, useSelector } from 'react-redux';
import {
  AssetInstance, AssetTypeTitles, MeterLabel, SensorLabel,
} from '../../constants/Types';
import CountWidget from './CountWidget';
import GridIcon from '../24pxIcons/GridIcon';
import TriangleDown from '../TriangleDown';
import Colors from '../../constants/Colors';
import Style from '../../constants/Style';
import TicketRow from './TicketRow';
import FlagIcon from '../FlagIcon';
import EditIcon24 from '../24pxIcons/EditIcon24';
import OccupancyIcon from '../24pxIcons/OccupancyIcon';
import SensorIcon24 from '../24pxIcons/SensorIcon24';
import PressableStyled, { PressableState } from '../PressableStyled';
import FilterIcon20 from '../20pxIcons/FilterIcon20';
import ScrollViewStyled from '../ScrollViewStyled';
import { resetSensorFilter, SensorsFilterState, updateSensorFilter } from '../../redux/sensorsFilterSlice';
import SearchIcon from '../SearchIcon';
import LocationIcon16 from '../16pxIcons/LocationIcon16';
import { SensorRow } from './SensorTabButton';
import { LocationSubtypeTitles } from './SetFloorsModal/FloorItem';
import PenIcon16 from '../16pxIcons/PenIcon16';
import RightArrow24 from '../24pxIcons/RightArrow24';
import OccupancyWidgets from './OccupancyWidgets';
import AssetRow from './AssetRow';
import { logEvent } from '../LogEvent';
import RightArrow from '../16pxIcons/RightArrow';
import { BuildingSettingsPriority } from '../../screens/LocationManagement/components/BuildingSettingsModal/data';
import { Building } from '../../screens/LocationManagement/components/AddBuildingModal';

const SideBar = (props) => {
  const {
    drawerOpen, smartGuardRoute, editMode, editorButtonPress,
    ticketsSelected, assetsSelected, occupancyShown, sensorsShown,
    setSelectedTab, showAreaList, setShowAreaList, areas, assets, sensors, searchValue,
    setSearchValue, selectedSpace, selectedArea, selectedFloor, setDrawPoints, setAreaComplete,
    setDrawMode, setSelectedSpace, setSelectedArea, tickets, occupancySelected,
    setSearchResultsPaneFocused, setFilterOpen, filterOpen, focusedLocationId, setSensors,
    setAssets, clientName, setLoading, showAlert, spaces, assetContextIndex, selectedTab,
    setEditingShape, setEditMode, setEditLocationType, setAssetContextIndex,
    setEditLocationId, setShapeName, setLocationSubtype, setLocationCapacity,
    setLocationExternalId, setBeingEdited, setHighPriority, savedScale, focusedAssetId,
    setMovingItem, setMovingAssetId, setDrawerOpen, anyFilterApplied,
  } = props;

  const sensorFilterHeight = useSharedValue<number>(0);
  const dispatch = useDispatch();

  const [sectionExpanded, setSectionExpanded] = React.useState<boolean>(false);

  const sensorsFilter: SensorsFilterState = useSelector((state:
    { sensorsFilter: SensorsFilterState }) => state.sensorsFilter);
  const happyEnabled = useSelector((state: { happyEnabled: { enabled: boolean } }) => state
    .happyEnabled.enabled);
  const isAdmin: boolean = useSelector((state:
    { user: { isAdmin: boolean } }) => state.user.isAdmin);
  const selectedBuildingId: string = useSelector((state:
    { selectedBuilding: { id: string } }) => state.selectedBuilding.id);
  const buildings: object | null | undefined = useSelector((state:
    { locations: { buildings } }) => state.locations.buildings);
  const selectedBuilding: Building | undefined | null = buildings
    ? buildings[selectedBuildingId] : null;
  const slaNames: string[] = useSelector(
    (state: { selectedBuilding: { SlaHours: BuildingSettingsPriority[] } }) => state
      .selectedBuilding.SlaHours?.map((item: BuildingSettingsPriority) => item.Name),
  );

  const sensorsFilterCount: number = Object.values(sensorsFilter)
    .filter((value: boolean) => value).length;

  useEffect(() => {
    if (!sectionExpanded) {
      setAssetContextIndex('');
    }
  }, [sectionExpanded]);

  const sensorFilterStyle = useAnimatedStyle(() => ({
    height: sensorFilterHeight.value,
    borderWidth: sensorFilterHeight.value === 0 ? 0 : 1.5,
  }));

  const getFilteredTicketsCount = (area: any, floor: any, space: any) => {
    if (space) return tickets.filter((t) => t.spaceId === space.LocationId).length;
    if (area) return tickets.filter((t) => t.areaId === area.LocationId).length;
    if (floor) return tickets.filter((t) => t.floorId === floor.LocationId).length;
    return tickets.length;
  };

  const TabText = ({ text, selected }) => (
    <Text style={[
      styles.bottomButtonStyle,
      {
        textAlign: 'left',
        paddingLeft: 8,
        color: selected ? '#fff'
          : Colors.light.hereworksBlack500,
      }]}>
      {text}
    </Text>
  );

  const renderAssetRow = (asset, index: number, isSensor: boolean = false) => {
    if (searchValue?.trim().length
      && !(asset.name?.toLowerCase().includes(searchValue?.toLowerCase())
        || asset.id?.toLowerCase().includes(searchValue?.toLowerCase()))) return null;
    return (
      <Pressable
        onHoverIn={() => {
          focusedAssetId.value = asset.id;
        }}
        onHoverOut={() => {
          focusedAssetId.value = null;
        }}
        style={{ zIndex: index * -1 }}
        testID={isSensor && `sensor#${index + 1}`}
      >
        <AssetRow
          key={`asset_${asset.id}`}
          {...{
            index, asset, editMode, setMovingItem, showAlert, isSensor, drawerOpen,
          }}
          editPosition={() => {
            setDrawerOpen(false);
            setMovingItem(true);
            setMovingAssetId(asset.id);
          }}
          move={() => {
            setMovingItem(true);
            setDrawerOpen(false);
            setDrawMode(false);
            asset.hasXY = true;
            asset.GeoY = 120;
            asset.GeoX = 20;
            setMovingAssetId(asset.id);
            asset.locationFloor = selectedFloor?.Name;
          }}
          removeAsset={() => {
            const newArr = Object.assign([], assetsSelected ? assets : sensors);
            newArr.forEach((a) => {
              if (asset.id === a.id) {
                delete a.GeoX;
                delete a.GeoY;
                a.hasXY = false;
                a.customFields = a.customFields.filter(
                  (field) => field.name !== 'GeoX' && field.name !== 'GeoY',
                );
              }
            });
            if (assetsSelected) setAssets(newArr);
            else setSensors(newArr);
          }}
          hideDrawer={() => { }}
          assetContextIndex={assetContextIndex}
          setAssetContextIndex={setAssetContextIndex}
          focusedAssetId={focusedAssetId.value}
          sectionExpanded={sectionExpanded}
        />
      </Pressable>
    );
  };

  const LocationsList = () => (
    <Animated.View
      style={{ flex: 1, alignSelf: 'stretch' }}>
      <ScrollView style={{ flex: 1, alignSelf: 'stretch', marginTop: 12 }}>
        {!selectedArea
          && areas.sort((prev, next) => prev?.name.toLowerCase()
            .localeCompare(next?.name.toLowerCase()))
            .map((area, key) => area && (
              <Pressable
                disabled={!area.polygon && !editMode}
                key={key}
                style={(state) => [styles.locationItemContainer, {
                  backgroundColor: focusedLocationId.value === area.LocationId
                    ? Colors.light.hereworksBlue50 : '#fff',
                  borderColor: focusedLocationId.value === area.LocationId || state.hovered
                    ? Colors.light.hereworksBlue500 : Colors.light.hereworksWhite500,
                }]} onPress={() => {
                  logEvent('Map', 'area_row');
                  if (!area.polygon) {
                    const areasCopy = Object.assign([], areas);
                    const areaToEdit = areasCopy.splice(key, 1);
                    setDrawPoints(areaToEdit[0]?.points ?? []);
                    setDrawMode(true);
                    setEditLocationType('area');
                    setEditLocationId(areaToEdit[0]?.LocationId);
                    setShapeName(areaToEdit[0]?.name ?? '');
                    setLocationSubtype(areaToEdit[0]?.LocationSubtype);
                    setLocationCapacity(areaToEdit[0]?.LocationCapacity);
                    setLocationExternalId(areaToEdit[0]?.ExternalId);
                    setHighPriority(areaToEdit[0]?.highPriority ?? false);
                    savedScale.value = 1;
                    setBeingEdited(area);
                    setEditingShape(true);
                    setEditMode(true);
                  } else {
                    setSelectedSpace(null);
                    setSelectedArea(area);
                  }
                }}>
                <View style={styles.locationIconContainer}>
                  <LocationIcon16 fill={Colors.light.hereworksBlue500} />
                </View>
                <View style={styles.listItemTextContainer}>
                  <Text style={styles.listItemLocationName} selectable>
                    {area.name}</Text>
                  <Text style={styles.listItemLocationType} selectable>
                    {LocationSubtypeTitles[area.LocationSubtype] ?? 'Area'}
                  </Text>
                </View>
                <View
                  style={[styles.listItemIconContainer]}
                  testID={(!area.polygon && editMode)
                    ? 'draw-area-on-the-map-btn'
                    : 'map-navigate-to-location-btn'}>
                  {(!area.polygon && editMode)
                    && <PenIcon16 color={Colors.light.hereworksBlue500} />}
                  {area.polygon ? <TriangleDown color={Colors.light.hereworksBlue500} style={{ transform: [{ rotateZ: '270deg' }] }} /> : <></>}
                </View>
              </Pressable>
            ))}
        {selectedArea
          && <>
            {!selectedSpace && spaces.sort((prev, next) => prev?.name
              .toLowerCase().localeCompare(next?.name.toLowerCase()))
              .map((space, key) => space && (
                <View key={key} style={styles.listItemContainer}>
                  <LocationIcon16 fill={Colors.light.hereworksBlue500} />
                  <View style={styles.listItemTextContainer}>
                    <Text style={styles.listItemLocationName}>
                      {space?.name}
                    </Text>
                    <Text style={styles.listItemLocationType}>
                      {LocationSubtypeTitles[space?.LocationSubtype] ?? 'Space'}
                    </Text>
                  </View>
                  <Pressable
                    disabled={selectedSpace?.LocationId === space.LocationId}
                    style={(state: PressableState) => [
                      styles.listItemIconContainer,
                      {
                        borderStartWidth:
                          (space.polygon || editMode || occupancyShown) ? 1 : 0,
                      },
                      {
                        opacity: (state.hovered
                          || selectedSpace?.LocationId === space.LocationId)
                          ? 0.5 : 1,
                      },
                    ]}
                    onPress={() => {
                      logEvent('Map', 'space_row');
                      setSelectedSpace(space);
                      setShowAreaList(false);
                    }}
                    testID='map-navigate-to-location-btn'
                  >
                    <RightArrow24 />
                  </Pressable>
                </View>
              ))}
          </>}
      </ScrollView>
    </Animated.View>
  );

  if (!drawerOpen) {
    return <View style={[styles.fillContainer, {
      paddingTop: 18, backgroundColor: '#fff', borderRightWidth: 1, borderColor: Colors.light.hereworksWhite500,
    }]}>
      {(isAdmin && !smartGuardRoute) && <View
        style={{
          borderBottomWidth: 1,
          borderColor: Colors.light.hereworksWhite500,
          marginBottom: 4,
        }}
        testID='side-menu-header'
      >
        <Pressable
          style={[
            styles.drawerEditButton,
            editMode && {
              backgroundColor: Colors.light.hereworksBlue500,
              borderColor: Colors.light.hereworksWhite100,
            },
          ]}
          onPress={() => editorButtonPress()}
          testID='map-edit-map-btn'
        >
          <EditIcon24 color={editMode ? '#fff' : Colors.light.hereworksBlue500} />
        </Pressable>
      </View>}
      {!editMode && <Pressable style={[
        styles.drawerButtonSmall,
        ticketsSelected && { backgroundColor: Colors.light.hereworksBlue500 }]}
        onPress={() => {
          logEvent('Map', 'tickets');
          if (!ticketsSelected) {
            setSelectedTab('tickets');
            setSectionExpanded(true);
          }
        }}
        testID='collapsed-map-tickets-btn'
      >
        <FlagIcon color={ticketsSelected ? '#fff' : Colors.light.hereworksBlue500} />
        {anyFilterApplied() && <View style={styles.filterCircle} />}
      </Pressable>}
      <Pressable style={[
        styles.drawerButtonSmall,
        assetsSelected && { backgroundColor: Colors.light.hereworksBlue500 }]}
        onPress={() => {
          logEvent('Map', 'assets');
          if (!assetsSelected) {
            setSelectedTab('assets');
            setSectionExpanded(true);
          }
        }}
        testID='collapsed-map-assets-side-menu-btn'
      >
        <GridIcon color={assetsSelected ? '#fff' : Colors.light.hereworksBlue500} />
      </Pressable>
      {(!editMode && happyEnabled) && <Pressable style={[
        styles.drawerButtonSmall,
        occupancySelected && { backgroundColor: Colors.light.hereworksBlue500 }]}
        onPress={() => {
          logEvent('Map', 'occupancy');
          setSelectedTab('occupancy');
          setSectionExpanded(true);
          setShowAreaList(true);
        }}
        testID='collapsed-map-occupancy-side-menu-btn'
      >
        <OccupancyIcon color={occupancySelected ? '#fff' : Colors.light.hereworksBlue500} />
      </Pressable>}
      {happyEnabled && <Pressable style={[
        styles.drawerButtonSmall,
        sensorsShown && { backgroundColor: Colors.light.hereworksBlue500 }]}
        onPress={() => {
          logEvent('Map', 'sensors');
          setSelectedTab('sensors');
          setSectionExpanded(true);
        }}
        testID='collapsed-map-sensors-side-menu-btn'
      >
        <SensorIcon24 color={sensorsShown ? '#fff' : Colors.light.hereworksBlue500} />
        {(sensorsShown && sensorsFilterCount > 0) ? <View
          style={styles.selectedCircle}>
          <Text style={styles.selectedText}>{sensorsFilterCount}</Text>
        </View> : null}
      </Pressable>}
    </View>;
  }
  return (<View style={[
    styles.fillContainer,
    {
      zIndex: drawerOpen ? 1 : -1,
      opacity: drawerOpen ? 1 : 1,
    },
  ]}>
    <View style={styles.drawerContainer}>
      {(isAdmin && !smartGuardRoute) && <PressableStyled style={[
        styles.drawerEditButtonExpanded,
        editMode && {
          backgroundColor: Colors.light.hereworksBlue500,
          borderColor: Colors.light.hereworksWhite100,
        }]}
        onPress={() => editorButtonPress()}
        testID='map-edit-map-btn'
      >
        <Text
          style={[styles.drawerEditButtonText, { color: editMode ? '#fff' : Colors.light.hereworksBlue500 }]}
        >{editMode ? 'Done' : 'Edit'}</Text>
        <EditIcon24 color={editMode ? '#fff' : Colors.light.hereworksBlue500} />
      </PressableStyled>}
      <View style={{
        padding: 12,
        marginBottom: 8,
        borderColor: Colors.light.hereworksBlue100,
        borderBottomWidth: 1,
        alignSelf: 'stretch',
      }}
        testID='side-menu-header'
      >
        {selectedArea ? <>
          <Pressable
            style={{ flexDirection: 'row', alignItems: 'center' }}
            onPress={() => {
              setSelectedSpace(null);
              setSelectedArea(null);
              setDrawPoints([]);
              setAreaComplete(false);
              setDrawMode(false);
              setLoading(true);
            }}
          >
            {selectedArea && <RightArrow />}
            <Text style={[styles.areaText]}>{selectedFloor?.Name ?? '-'}</Text>
          </Pressable>
          {selectedSpace ? <>
            <Pressable
              style={{ marginLeft: 16, flexDirection: 'row', alignItems: 'center' }}
              onPress={() => setSelectedSpace(null)}
            >
              <RightArrow />
              <Text style={styles.areaText}>
                {selectedArea?.name}
              </Text>
            </Pressable>
            <View style={[styles.locationHead, { marginLeft: 32 }]}>
              <Text style={styles.spaceText}>{selectedSpace?.name}</Text>
            </View>
          </> : <View style={[styles.locationHead, { marginLeft: 18 }]}>
            <Text style={styles.spaceText}>{selectedArea?.name}</Text>
          </View>}
        </> : <Text style={[smartGuardRoute
          ? styles.spaceText : styles.areaText]}>
          {selectedFloor?.Name ?? '-'}
        </Text>}
      </View>
      {!editMode && <View style={[styles.sidebarTab, ticketsSelected && {
        borderColor: Colors.light.hereworksBlue500,
      }, (sectionExpanded && ticketsSelected) && { flex: 1 }]}>
        <Pressable
          onPress={() => {
            logEvent('Map', 'tickets');
            if (selectedTab !== 'tickets') {
              setSelectedTab('tickets');
              setSectionExpanded(true);
            } else {
              setSectionExpanded(!sectionExpanded);
            }
            setShowAreaList(false);
          }}
          style={(state) => [styles.sidebarButton, {
            backgroundColor: ticketsSelected
              ? Colors.light.hereworksBlue500 : Colors.light.hereworksWhite100,
          }, state.hovered && Style.hovered]}
          testID='map-tickets-btn'
        >
          <FlagIcon color={ticketsSelected ? '#fff' : Colors.light.hereworksBlue500} />
          <TabText text='TICKETS' selected={ticketsSelected} />
          {ticketsSelected && <Pressable onPress={() => {
            logEvent('Map', 'filter_tickets');
            setFilterOpen(!filterOpen);
          }}
            style={(state) => [{
              borderWidth: 1,
              borderRadius: 8,
              borderColor: state.hovered ? '#fff' : 'transparent',
            }]}
            testID='filter-tickets-btn'
          >
            <FilterIcon20 />
            {anyFilterApplied() && <View style={styles.filterCircle} />}
          </Pressable>}
          <TriangleDown
            color={ticketsSelected ? '#fff' : Colors.light.hereworksBlue500}
            style={{ marginRight: 12, transform: [{ rotateZ: sectionExpanded ? '180deg' : '0deg' }] }} />
        </Pressable>
        {(ticketsSelected && sectionExpanded) && <>
          <View style={[Style.row, { marginTop: 16, paddingHorizontal: 12 }]}>
            <CountWidget
              title='Tickets'
              count={getFilteredTicketsCount(selectedArea, selectedFloor, selectedSpace)}
              action={() => {
                logEvent('Map', 'show_tickets');
                setShowAreaList(false);
              }}
              selected={!showAreaList}
              testID='tickets-label'
            />
            <CountWidget
              title={selectedArea ? 'Spaces' : 'Locations'}
              count={selectedArea ? spaces.length : areas.length}
              action={() => {
                logEvent('Map', 'locations');
                setShowAreaList(true);
              }}
              selected={showAreaList}
              testID='locations-label-btn'
            />
          </View>
          {showAreaList ? <LocationsList /> : <ScrollView
            style={{ alignSelf: 'stretch', marginTop: 12 }}
            testID='tickets-side-menu'
          >
            {tickets.length === 0 && <Text style={styles.noAssetsText}>
              {'No tickets in this location'}
            </Text>}
            {tickets.map((ticket, index) => {
              const hasGeoX = ticket.asset?.customFields.some(
                (field) => field.name === 'GeoX' && Number(field.value) > 0,
              );
              if (!hasGeoX || !ticketsSelected || editMode
                || (selectedFloor
                  && ticket.floorId !== selectedFloor?.LocationId)
                || (selectedArea
                  && ticket.areaId !== selectedArea?.LocationId)
                || (selectedSpace
                  && ticket.spaceId !== selectedSpace?.LocationId)) {
                return null;
              }
              return (
                <TicketRow
                  {...{
                    ticket, showAlert, slaNames, index,
                  }}
                  key={`ticket_row_${ticket.id}`}
                  clientId={clientName}
                />
              );
            })}
          </ScrollView>}</>}
      </View>}
      <>
        <View style={[styles.sidebarTab, assetsSelected && {
          borderColor: Colors.light.hereworksBlue500,
        }, (sectionExpanded && assetsSelected) && { flex: 1 }]}>
          <Pressable
            onPress={() => {
              logEvent('Map', 'assets_tab');
              if (selectedTab !== 'assets') {
                setSelectedTab('assets');
                setSectionExpanded(true);
              } else {
                setSectionExpanded(!sectionExpanded);
              }
            }}
            style={(state) => [styles.sidebarButton, {
              backgroundColor: assetsSelected
                ? Colors.light.hereworksBlue500 : Colors.light.hereworksWhite100,
            }, state.hovered && Style.hovered]}
            testID='map-assets-side-menu-btn'>
            <GridIcon color={assetsSelected ? '#fff' : Colors.light.hereworksBlue500} />
            <TabText text='ASSETS' selected={assetsSelected} />
            <TriangleDown
              color={assetsSelected ? '#fff' : Colors.light.hereworksBlue500}
              style={{ marginRight: 12, transform: [{ rotateZ: sectionExpanded ? '180deg' : '0deg' }] }} />
          </Pressable>
          {(assetsSelected && sectionExpanded) && <>
            <View style={[Style.row, { marginTop: 16, paddingHorizontal: 12 }]}>
              <CountWidget
                title={selectedArea ? 'Spaces' : 'Locations'}
                count={selectedArea ? spaces.length : areas.length}
                action={() => {
                  logEvent('Map', 'locations');
                  setShowAreaList(true);
                }}
                selected={showAreaList}
                testID='locations-label-btn'
              />
              <CountWidget
                title="Assets"
                count={assets.length}
                action={() => {
                  logEvent('Map', 'show_assets');
                  setShowAreaList(false);
                }}
                selected={!showAreaList}
                testID='assets-label-btn'
              />
            </View>
            {(!showAreaList && assetsSelected) ? (
              <Animated.View
                style={{ alignSelf: 'stretch', flex: 1 }}>
                <ScrollView style={{ alignSelf: 'stretch' }}>
                  {assetsSelected
                    && <View testID='map-asset-list' style={{ marginTop: 12 }}>
                      <View style={styles.searchBox}>
                        <SearchIcon style={{ marginLeft: 14 }} />
                        <TextInput
                          placeholder="Search by name or ID"
                          placeholderTextColor={Colors.light.hereworksBlack400}
                          value={searchValue}
                          style={styles.searchText}
                          // onFocus={() => setSearchResultsPaneFocused(false)}
                          onChangeText={setSearchValue}
                          onKeyPress={(e) => {
                            // @ts-ignore
                            if (e.code === 'ArrowDown') setSearchResultsPaneFocused(true);
                          }}
                        />
                      </View>
                      {assets?.length > 0 ? assets
                        .sort((prev: AssetInstance, next: AssetInstance) => prev.name
                          .toLowerCase().localeCompare(next.name.toLowerCase()))
                        .map((asset, index: number) => renderAssetRow(asset, index))
                        : <Text style={styles.noAssetsText}>
                          {'No assets in this location'}
                        </Text>}
                    </View>}
                </ScrollView>
              </Animated.View>
            ) : <LocationsList />}</>}
        </View>
        {(!editMode && happyEnabled) && <View style={[styles.sidebarTab, occupancySelected && {
          borderColor: Colors.light.hereworksBlue500,
        }, (sectionExpanded && occupancySelected) && { flex: 1 }]}>
          <Pressable
            onPress={() => {
              logEvent('Map', 'occupancy_tab');
              if (selectedTab !== 'occupancy') {
                setSelectedTab('occupancy');
                setSectionExpanded(true);
              } else {
                setSectionExpanded(!sectionExpanded);
              }
            }}
            style={(state) => [styles.sidebarButton, {
              backgroundColor: occupancySelected
                ? Colors.light.hereworksBlue500 : Colors.light.hereworksWhite100,
            }, state.hovered && Style.hovered]}
            testID='map-occupancy-side-menu-btn'>
            <OccupancyIcon color={occupancySelected ? '#fff' : Colors.light.hereworksBlue500} />
            <TabText text='OCCUPANCY' selected={occupancySelected} />
            <TriangleDown
              color={occupancySelected ? '#fff' : Colors.light.hereworksBlue500}
              style={{ marginRight: 12, transform: [{ rotateZ: sectionExpanded ? '180deg' : '0deg' }] }} />
          </Pressable>
          {(occupancySelected && sectionExpanded)
            && <>
              {!selectedArea && <View style={[{ marginTop: 16, paddingHorizontal: 16, alignItems: 'flex-start' }]}>
                <CountWidget
                  title={selectedArea ? 'Spaces' : 'Locations'}
                  count={selectedArea ? spaces.length : areas.length}
                  action={() => {
                    logEvent('Map', 'locations');
                    setShowAreaList(true);
                  }}
                  selected={true}
                  extraPadding
                  testID='locations-label-btn'
                />
              </View>}
              {selectedArea ? <OccupancyWidgets
                name={(selectedSpace ?? selectedArea)?.name}
                locationType={(selectedSpace ?? selectedArea)?.LocationSubtype}
                goBack={() => {
                  if (selectedSpace) setSelectedSpace(null);
                  else setSelectedArea(null);
                }}
                buildingId={selectedBuildingId}
                floorId={selectedFloor?.LocationId}
                areaId={selectedArea?.LocationId}
                capacity={selectedArea?.LocationCapacity ?? 0}
                occupancyPercentage={selectedArea?.occupancyPercentage ?? 0}
                spaceId={selectedSpace?.LocationId}
                externalId={(selectedSpace ?? selectedArea ?? selectedFloor
                  ?? selectedBuilding)?.ExternalId}
              /> : <LocationsList />}</>}
        </View>}
        {happyEnabled && <View style={[styles.sidebarTab, sensorsShown && {
          borderColor: Colors.light.hereworksBlue500,
        }, (sectionExpanded && sensorsShown) && { flex: 1 }]}>
          <Pressable
            onPress={() => {
              logEvent('Map', 'sensors_tab');
              setShowAreaList(false);
              if (selectedTab !== 'sensors') {
                setSelectedTab('sensors');
                setSectionExpanded(true);
              } else {
                setSectionExpanded(!sectionExpanded);
              }
            }}
            style={(state) => [styles.sidebarButton, {
              backgroundColor: sensorsShown
                ? Colors.light.hereworksBlue500 : Colors.light.hereworksWhite100,
              zIndex: 2,
            }, state.hovered && Style.hovered]}
            testID='map-sensors-side-menu-btn'>
            <SensorIcon24 color={sensorsShown ? '#fff' : Colors.light.hereworksBlue500} />
            <TabText text='SENSORS & METERS' selected={sensorsShown} />
            {sensorsShown && <Pressable onPress={() => {
              if (sensorFilterHeight.value === 0) sensorFilterHeight.value = withTiming(340);
              else sensorFilterHeight.value = withTiming(0);
            }}
              style={(state) => [{
                borderWidth: 1,
                borderRadius: 8,
                borderColor: state.hovered ? '#fff' : 'transparent',
              }]}
              testID='filter-sensors-btn'
            >
              <FilterIcon20 />
            </Pressable>}
            <TriangleDown
              color={sensorsShown ? '#fff' : Colors.light.hereworksBlue500}
              style={{ marginRight: 12, transform: [{ rotateZ: sectionExpanded ? '180deg' : '0deg' }] }} />
            <Animated.View style={[styles.sensorFilter, sensorFilterStyle]}>
              <Pressable style={[Style.row, { padding: 8 }]}>
                <Text style={{
                  fontSize: 14,
                  lineHeight: 21,
                  fontFamily: 'Poppins_600SemiBold',
                  color: Colors.light.hereworksBlack600,
                }}>{'Sensors'}</Text>
                {sensorsFilterCount > 0
                  ? <PressableStyled
                    onPress={() => dispatch(resetSensorFilter())}
                    testID='reset-filter-sensors-btn'
                  >
                    <Text>{'RESET'}</Text>
                  </PressableStyled> : <Text>{'Showing all sensors'}</Text>}
              </Pressable>
              <ScrollViewStyled testID='filter-sensors-list'>
                {[...Object.values(SensorLabel), ...Object.values(MeterLabel)]
                  .map((key: string, index: number) => <SensorRow
                    key={`sensor_filter_${key}`}
                    label={`${AssetTypeTitles[key]} (${key})`}
                    enabled={sensorsFilter[key]}
                    onPress={() => dispatch(updateSensorFilter({
                      key, value: !sensorsFilter[key],
                    }))}
                    testID={`checkbox#${index + 1}`}
                  />)}
              </ScrollViewStyled>
            </Animated.View>
          </Pressable>
          {(sensorsShown && sectionExpanded) && <>
            <View style={[Style.row, { marginTop: 16, paddingHorizontal: 12 }]}>
              <CountWidget
                title={selectedArea ? 'Spaces' : 'Locations'}
                count={selectedArea ? spaces.length : areas.length}
                action={() => {
                  logEvent('Map', 'locations');
                  setShowAreaList(true);
                }}
                selected={showAreaList}
                testID='locations-label-btn'
              />
              <CountWidget
                title="Sensors"
                count={sensors.length}
                action={() => {
                  logEvent('Map', 'show_sensors');
                  setShowAreaList(false);
                }}
                selected={!showAreaList}
                testID='sensors-label-btn'
              />
            </View>
            {showAreaList ? <LocationsList /> : <Animated.View
              style={{
                alignSelf: 'stretch', flex: 1, zIndex: 1, marginTop: 12,
              }}>
              <ScrollView
                style={{ alignSelf: 'stretch' }}
                testID='sensors-list-side-menu'
              >
                {(sensors?.length > 0 ? sensors
                  .sort((prev: AssetInstance, next: AssetInstance) => prev.name
                    .toLowerCase().localeCompare(next.name.toLowerCase()))
                  .map((sensor, index: number) => {
                    if (sensorsFilterCount) {
                      let enabled = false;
                      (sensor.labels ?? []).forEach((label) => {
                        if (enabled) return;
                        enabled = sensorsFilter[label];
                      });
                      if (!enabled) return null;
                    }
                    return <>{renderAssetRow(sensor, index, true)}</>;
                  })
                  : <Text style={styles.noAssetsText}>
                    {'No sensors in this location'}
                  </Text>)}
              </ScrollView>
            </Animated.View>}
          </>}
        </View>}
      </>
    </View>
  </View>
  );
};

export default SideBar;

const styles = StyleSheet.create({
  fillContainer: {
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
  },
  drawerEditButton: {
    width: 32,
    height: 32,
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    marginHorizontal: 10,
    marginVertical: 4,
    marginBottom: 10,
    backgroundColor: '#fff',
    borderColor: Colors.light.hereworksBlue500,
    borderWidth: 1,
    borderRadius: 4,
  },
  drawerEditButtonExpanded: {
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    marginHorizontal: 10,
    marginVertical: 4,
    padding: 2,
    marginBottom: 10,
    backgroundColor: '#fff',
    borderColor: Colors.light.hereworksBlue500,
    borderWidth: 1,
    borderRadius: 4,
    position: 'absolute',
    flexDirection: 'row',
    right: 0,
    top: 10,
    zIndex: 3,
  },
  drawerEditButtonText: {
    fontFamily: 'Poppins_600SemiBold',
    color: Colors.light.hereworksBlue500,
    marginHorizontal: 4,
  },
  drawerButtonSmall: {
    width: 44,
    height: 44,
    justifyContent: 'center',
    alignItems: 'center',
    marginHorizontal: 10,
    marginVertical: 4,
    backgroundColor: Colors.light.hereworksWhite100,
    borderRadius: 8,
  },
  spaceText: {
    paddingLeft: 8,
    fontSize: 18,
    fontFamily: 'Poppins_600SemiBold',
    color: Colors.light.hereworksBlack600,
  },
  locationHead: {
    marginLeft: 8,
    flexDirection: 'row',
    alignItems: 'center',
  },
  sidebarButton: {
    alignItems: 'center',
    flexDirection: 'row',
    alignSelf: 'stretch',
    paddingLeft: 12,
    borderRadius: 8,
  },
  sidebarTab: {
    borderColor: 'transparent',
    borderWidth: 1,
    alignSelf: 'stretch',
    borderRadius: 10,
    marginHorizontal: 24,
    marginVertical: 2,
  },
  areaText: {
    paddingLeft: 8,
    fontSize: 18,
    fontFamily: 'Poppins_400Regular',
    color: Colors.light.hereworksBlack400,
  },
  noAssetsText: {
    flex: 1,
    textAlign: 'center',
    alignSelf: 'center',
    marginTop: '49%',
    fontSize: 14,
    lineHeight: 21,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlack400,
  },
  drawerContainer: {
    backgroundColor: '#fff',
    borderRightWidth: 1,
    borderColor: Colors.light.hereworksBlue100,
    width: 400,
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    left: 0,
    height: '100%',
    flex: 1,
    overflow: 'hidden',
    paddingBottom: 18,
  },
  bottomButtonStyle: {
    fontFamily: 'Poppins_600SemiBold',
    color: '#fff',
    paddingVertical: 16,
    paddingHorizontal: 24,
    textAlign: 'center',
    flex: 1,
  },
  locationItemContainer: {
    paddingLeft: 8,
    marginHorizontal: 16,
    alignSelf: 'stretch',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
    borderRadius: 8,
    borderWidth: 1,
    height: 44,
  },
  selectedCircle: {
    backgroundColor: Colors.light.hereworksDarkBlue50,
    width: 18,
    height: 18,
    borderRadius: 9,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    right: -6,
    bottom: -6,
  },
  filterCircle: {
    backgroundColor: Colors.light.hereworksUrgentRed,
    width: 8,
    height: 8,
    borderRadius: 4,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    right: -6,
    top: -6,
  },
  selectedText: {
    fontFamily: 'Roboto_700Bold',
    fontSize: 13,
    lineHeight: 18,
    color: Colors.light.hereworksBlue500,
  },
  listItemTextContainer: {
    flex: 1,
    marginStart: 8,
  },
  locationIconContainer: {
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: Colors.light.hereworksBlue50,
    alignItems: 'center',
    justifyContent: 'center',
    marginEnd: 8,
    borderWidth: 1,
    borderColor: Colors.light.hereworksBlue500,
  },
  listItemLocationName: {
    fontFamily: 'Poppins_500Medium',
    fontSize: 14,
    color: Colors.light.hereworksBlack600,
    lineHeight: 18,
  },
  listItemLocationType: {
    fontSize: 10,
    lineHeight: 12,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlack400,
    marginTop: 2,
  },
  listItemIconContainer: {
    padding: 10,
    alignItems: 'center',
    justifyContent: 'center',
    borderStartColor: Colors.light.hereworksBlue100,
    height: 44,
    width: 44,
  },
  listItemContainer: {
    borderWidth: 1,
    borderColor: Colors.light.hereworksBlue100,
    borderRadius: 8,
    paddingStart: 10,
    marginHorizontal: 24,
    alignSelf: 'stretch',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
    height: 44,
  },
  searchBox: {
    flex: 1,
    borderRadius: 24,
    paddingVertical: 8,
    backgroundColor: '#fff',
    borderColor: Colors.light.hereworksBlue50,
    borderWidth: 1.5,
    flexDirection: 'row',
    alignItems: 'center',
    marginHorizontal: 24,
    marginBottom: 8,
  },
  searchText: {
    flex: 1,
    color: Colors.light.hereworksBlack600,
    marginLeft: 9,
    fontFamily: 'Roboto_400Regular',
    fontSize: 14,
    lineHeight: 16.4,
    marginVertical: 8,
    outlineWidth: 0,
  },
  sensorFilter: {
    position: 'absolute',
    width: 274,
    backgroundColor: '#fff',
    top: 54,
    right: 0,
    overflow: 'hidden',
    borderRadius: 10,
    borderColor: Colors.light.hereworksBlue100,
  },
});
